import monsteraImage from '@/assets/fresh-monstera.jpg';

export const ManifestSection = () => {
  return (
    <section id="manifest" className="py-24 bg-background relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{ backgroundImage: `url(${monsteraImage})` }}
      >
        <div className="absolute inset-0 bg-background/80"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div className="text-center mb-8">
          <h2 className="text-5xl md:text-7xl font-serif font-light mb-6 text-foreground leading-tight">
            Manifesto
          </h2>
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-accent to-transparent mx-auto mb-6"></div>
        </div>

        {/* Main Content - Centered Layout */}
        <div className="space-y-12">
          {/* Main Content */}
          <div className="relative bg-gradient-earth shadow-bold p-8 md:p-12 rounded-xl border border-border/30 backdrop-blur-sm transition-all duration-300">
            <div className="relative space-y-6 text-base md:text-lg leading-relaxed text-muted-foreground text-center max-w-3xl mx-auto">
              {/* The Motto */}
              <p className="text-2xl md:text-3xl text-foreground font-serif font-light leading-tight mb-8">
                <span className="relative inline-block">
                  <span className="absolute inset-0 bg-lime-400 opacity-60 transform -rotate-1 rounded-sm -z-10"></span>
                  <span className="relative px-2 py-1">Offline</span>
                </span>{' '}
                is the new luxury
              </p>
              <p>
                In a world where everything is always on, always available, always demanding your attention — 
                <span className="text-foreground font-medium"> the ability to disconnect has become rare</span>.
              </p>
              
              <p>
                Luxury used to mean more — more things, more experiences, more stimulation. 
                But true luxury today is found in <span className="text-foreground font-medium">less</span>: 
                less noise, less distraction, less performance.
              </p>
              
              <p>
                <span className="text-foreground font-medium">Offline is freedom.</span> Freedom to be fully present. 
                Freedom to connect with yourself and others without the constant pull of notifications. 
                Freedom to simply exist without documenting or broadcasting every moment.
              </p>
              
              <p>
                At Mystic Forest, we believe that choosing to go offline — 
                even for a weekend, even for a few hours — is an act of self-care and rebellion against the culture of busyness.
              </p>
              
              <p className="text-foreground font-semibold text-xl pt-4">
                It's not about rejecting technology. It's about reclaiming your time, attention, and inner peace.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};